<h1 mat-dialog-title>
    <span [translate]="'admin.frais.prestations.detail.reglesGestion.remboursement.montant.detail.' + (isCreation ? 'creation' : 'modification')"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm" style="height: 100px;">
        <div class="row">
            <custom-input
                    ngDefaultControl
                    id="dateAppli"
                    name="dateAppli"
                    [ngModel]="montant.dateApplication"
                    [(customModel)]="montant.dateApplication"
                    customType="date"
                    [lCol]="3"
                    [rCol]="3"
                    libelle="admin.frais.prestations.detail.reglesGestion.remboursement.montant.detail.dateApplicaton"
                    [required]="true"
                    [disabled]="!isCreation"
            ></custom-input>
            <custom-input
                    ngDefaultControl
                    id="taux"
                    name="taux"
                    [(ngModel)]="montant.taux"
                    customType="number"
                    [lCol]="3"
                    [rCol]="3"
                    [nbDecimales]="2"
                    libelle="admin.frais.prestations.detail.reglesGestion.remboursement.montant.detail.montantUnitaire"
                    [required]=" true"
            ></custom-input>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button color="warn" (click)="onDelete()" [disabled]="isPending"><span [translate]="'global.actions.supprimer'"></span></button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="form?.invalid || isPending"><span [translate]="'global.actions.enregistrer'"></span></button>
</div>